import { Card, Loading, Row } from '@folio/stripes/components';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { CriteriaGroupType, CriteriaTerminalType } from '../../types';
import css from '../Card.module.css';
import CriteriaAge from './CriteriaAge';
import CriteriaAmount from './CriteriaAmount';
import CriteriaCardSelect from './CriteriaCardSelect';
import CriteriaCardToolbox from './CriteriaCardToolbox';
import CriteriaFeeFineOwner from './CriteriaFeeFineOwner';
import CriteriaFeeFineType from './CriteriaFeeFineType';
import CriteriaLocation from './CriteriaLocation';
import CriteriaPatronGroup from './CriteriaPatronGroup';
import CriteriaServicePoint from './CriteriaServicePoint';
function renderCriteriaNoneOf(_a) {
    var fields = _a.fields;
    return (fields.map(function (name, index) { return (
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    React.createElement(CriteriaCard, { key: name, name: name, alone: fields.length === 1, onRemove: function () { return fields.remove(index); } })); }));
}
export default function CriteriaCard(_a) {
    var _b;
    var name = _a.name, onRemove = _a.onRemove, _c = _a.root, root = _c === void 0 ? false : _c, _d = _a.patronOnly, patronOnly = _d === void 0 ? false : _d, alone = _a.alone;
    var type = useField("".concat(name, ".type"), {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : CriteriaTerminalType.PASS; },
    }).input.value;
    var noneOfReturnType = useMemo(function () { return (React.createElement(FieldArray, { name: "".concat(name, ".criteria") }, function (_a) {
        var fields = _a.fields;
        return renderCriteriaNoneOf({ fields: fields });
    })); }, [name]);
    var cardInterior = useMemo(function () {
        switch (type) {
            case CriteriaTerminalType.PASS:
                return React.createElement("div", null);
            case CriteriaGroupType.ALL_OF:
            case CriteriaGroupType.ANY_OF:
            case CriteriaGroupType.NONE_OF:
                return (noneOfReturnType);
            case CriteriaTerminalType.AGE:
                return (React.createElement(Row, null,
                    React.createElement(CriteriaAge, { prefix: "".concat(name, ".") })));
            case CriteriaTerminalType.AMOUNT:
                return (React.createElement(Row, null,
                    React.createElement(CriteriaAmount, { prefix: "".concat(name, ".") })));
            case CriteriaTerminalType.FEE_FINE_OWNER:
                return (React.createElement(Row, null,
                    React.createElement(CriteriaFeeFineOwner, { prefix: "".concat(name, ".") })));
            case CriteriaTerminalType.FEE_FINE_TYPE:
                return (React.createElement(Row, null,
                    React.createElement(CriteriaFeeFineType, { prefix: "".concat(name, ".") })));
            case CriteriaTerminalType.LOCATION:
                return (React.createElement(Row, null,
                    React.createElement(CriteriaLocation, { prefix: "".concat(name, ".") })));
            case CriteriaTerminalType.SERVICE_POINT:
                return (React.createElement(Row, null,
                    React.createElement(CriteriaServicePoint, { prefix: "".concat(name, ".") })));
            case CriteriaTerminalType.PATRON_GROUP:
                return (React.createElement(Row, null,
                    React.createElement(CriteriaPatronGroup, { prefix: "".concat(name, ".") })));
            default:
                return React.createElement(Loading, null);
        }
    }, [name, noneOfReturnType, type]);
    return (React.createElement(Card, { cardClass: css.cardClass, headerClass: css.headerClass, headerStart: React.createElement(CriteriaCardSelect, { name: "".concat(name, ".type"), root: root, patronOnly: patronOnly }), headerEnd: React.createElement(CriteriaCardToolbox, { prefix: "".concat(name, "."), root: root, alone: alone, onRemove: onRemove }), bodyClass: classNames((_b = {},
            _b[css.emptyBody] = type === CriteriaTerminalType.PASS,
            _b)) }, cardInterior));
}
